import { h, Component } from 'preact';

export class BaseSkin extends Component {
    constructor(...args) {
        super(...args);
        this.className = '';
    }

    render() {
        return (
            <style id={ `skin-${this.className}` }>
                { this.styleContents }
                { this.props.children }
                { this.styleOverrideContents }
            </style>
        );
    }

    get styleContents() {
        return '';
    }

    get styleOverrideContents() {
        return '';
    }
}